import React, {useEffect} from 'react';
import {useSelector} from "react-redux";
import {useGetPilotRegistrationPackQuery} from "../../slices/apiSlice";
import Box from "@mui/material/Box";
import PilotInfo2 from "./PilotInfo2";
import Button from "@mui/material/Button";
import {eventStatus} from "../../util/standards-util";
import {Alert} from "@mui/material";
import {useNavigate} from "react-router-dom";
import Typography from "@mui/material/Typography";

const RegistrationInfo = ({}) => {
    const event = useSelector(state => state.session.event)
    const navigate = useNavigate()

    const [hasRegistration, setHasRegistration] = React.useState(false)

    const {data, isSuccess} =
        useGetPilotRegistrationPackQuery(event?.id,{skip:event === undefined})

    const handleRegisterClicked = (e) => {
        navigate(`/eventRegistration/${event.id}`)
    }

    useEffect(() => {
        if (isSuccess) {
            setHasRegistration(data.status==='ok')
        }
    }, [isSuccess]);

    return (
        <Box>
            {isSuccess && hasRegistration ?
                <PilotInfo2 entry={data} event={event} isModal={false} isAdminMode={false}/>
                :
                event.status===eventStatus.STATUS_PLANNED ?
                    <Box>
                        <Box my={4}>
                            <Alert severity={'info'}>You are not registered for this event</Alert>
                        </Box>
                        <Button variant={'contained'} onClick={handleRegisterClicked}>Register</Button>
                    </Box>
                    :
                    <Alert severity={'info'} my={4}>Registration for this event is closed</Alert>
            }
        </Box>
    );
};

export default RegistrationInfo;